import {IPhoneSwitcherWrapper} from "../styles";
import {FC} from "react";

export const IPhoneSwitcher: FC<{ active?: boolean, setActive?: (value: boolean) => void }> = ({active, setActive}) => {

    return (
        <IPhoneSwitcherWrapper active={active} onClick={() => setActive && setActive(!active)}>
            <div/>
        </IPhoneSwitcherWrapper>
    )
}import {IPhoneSwitcherWrapper} from "../styles";
import {FC} from "react";

export const IPhoneSwitcher: FC<{ active?: boolean, setActive?: (value: boolean) => void }> = ({active, setActive}) => {

    return (
        <IPhoneSwitcherWrapper active={active} onClick={() => setActive && setActive(!active)}>
            <div/>
        </IPhoneSwitcherWrapper>
    )
}